module.exports = __webpack_public_path__ + "static/media/gin.5f45dc02.svg";